import React from "react";
import { useHistory } from 'react-router';

import useComponentVisible from "../../../utils/visible/visible";
import { ITopBarMenuComponentProps } from "./ITopBarMenuComponentsProps";
import { authorizeActions } from "../../../store/actions";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import miscUtils from "../../../utils/miscUtils";
import { Map } from "immutable";
import { useQueryClient } from 'react-query';
import './top-bar-menu.scss'
import { AppContext } from "containers/main/MainComponent";
// import { UserService } from "api/services/users";
// import store from "store/configureStore";

const TopBarMenuComponent: React.FC<ITopBarMenuComponentProps> = props => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const { logout, group, disableLogout } = props;

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);

  const appContext = React.useContext(AppContext);

  const groupHomePage = Boolean(window.location.href === miscUtils.getBaseDomain() + "/")
  const [isValidImage, setIsValidImage] = React.useState(true);
  const onImageError = (e: any) => {
    setIsValidImage(false)
  }
 const { loggedinUser, } = appContext;

  const user = loggedinUser


  if (!loggedinUser) {
    return <></>
  }
  return (
    <div
      className={`header-settings dropdown-menu ${props.lectureView ? 'header-settings-lecture' : ''}`} ref={ref}>
      <div onClick={() => setIsComponentVisible(true)}>
        {
          (user.profile_image && isValidImage) ?
            <img
              alt='user profile'
              className='logout-profile-image'
              src={user.profile_image}
              onError={onImageError}
            />
            :
            <>
              {
                user.full_name !== null ?
                  <div
                    className='logout-profile-image'
                    data-color={miscUtils.getColorInitial(`${user.full_name}`)}
                  >
                    {miscUtils.getNameInitials(user.full_name)}
                  </div>
                  :
                  <div
                    className='logout-profile-image'
                    data-color={miscUtils.getColorInitial('No name')}
                  >
                    {miscUtils.getNameInitials('No name')}
                  </div>
              }
            </>
        }
      </div>

      {isComponentVisible && (
        <ul className="logout-popup">

          <span>ACCOUNT</span>
          <div className="logout-popup-acc">
            <div className="logout-popup-acc-first">
              {
                (user.profile_image && isValidImage) ?
                  <img
                    alt='user profile'
                    className='logout-popup-acc-first-image'
                    src={user.profile_image}
                    onError={onImageError}
                  />
                  :
                  <>
                    {
                      user.full_name !== null ?
                  <div
                    className='logout-popup-acc-first-image'
                    data-color={miscUtils.getColorInitial(`${user.full_name}`)}
                  >
                    {miscUtils.getNameInitials(user.full_name)}
                  </div>
                        :
                        <div
                          className='logout-popup-acc-first-image'
                          data-color={miscUtils.getColorInitial('No name')}
                        >
                          {miscUtils.getNameInitials('No name')}
                        </div>
                    }
                  </>
              }
            </div>
            <div className="logout-popup-acc-second">
              {
                user.full_name !== null ?
                  <h1>{user.full_name}</h1>
                  :
                  <h1>No name</h1>
              }
              <small>{user.email}</small>
            </div>
          </div>
          {
            groupHomePage &&
            <li onClick={() => {
              setIsComponentVisible(false)
              history.push({
                pathname: "/about",
                search: "?section=profile-details&hideNotification=true"
              })
            }}>
                Profile details
            </li>
          }

          {
            group &&
            group.menu['profile']['show'] &&
            group.user_membership &&
            miscUtils.isActiveCommunityMember(group.user_membership) &&
            !groupHomePage &&
            <>
              <li onClick={() => {
                setIsComponentVisible(false);
                miscUtils.scrollToTop();
                history.push({
                  pathname: "/about",
                  search: groupHomePage
                    ? "?section=profile-details&hideNotification=true"
                    : "?section=profile-details"
                });

              }}>
                Profile details
              </li>

              <li onClick={() => {
                setIsComponentVisible(false);
                miscUtils.scrollToTop();
                history.push({
                  pathname: "/about",
                  search: "?section=notification-settings"
                })
              }}>
                Notification settings
              </li>

              {
                group &&
                group.menu['billing']['show'] &&
                !miscUtils.isTeamMember(group.user_membership) &&
                <li onClick={() => {
                  setIsComponentVisible(false);
                  miscUtils.scrollToTop();
                  history.push({
                    pathname: "/about",
                    search: "?section=billing-details"
                  })
                }}>
                    Billing
                </li>
              }
            </>
          }


          {
            group &&
            miscUtils.isSubscriptionPaymentCanceled(group) &&
            group.user_membership.previous_subscription &&
            group.user_membership.previous_subscription.plan &&
            group.user_membership.previous_subscription.plan.collection_type === "group" &&
            !group.user_membership.parent_membership_id &&
            !miscUtils.isTeamMember(group.user_membership)  ? (
              <li onClick={() => {
                setIsComponentVisible(false);
                miscUtils.scrollToTop();
                history.push({
                  pathname: "/about",
                  search: "?section=billing-details"
                })
              }}>
                  Billing
              </li>
            ) : <></>
          }
          <li
            onClick={() => {
              if (disableLogout) return
              if(appContext.resetGroupDataRef && appContext.resetGroupDataRef.current) {
                appContext.resetGroupDataRef.current();
              }
                if(appContext.setGroup ) {
                appContext.setGroup(null);
              }
              queryClient.clear();
              logout(group, props.subdomain)
            }}
            className="logout-button"
          >
            Log out
          </li>
        </ul>
      )}
    </div>
  );
};

const mapStateToProps = (
  state: Map<string, any>,
  ownProps: ITopBarMenuComponentProps
) => {
  const uid: string = state.getIn(["authorize", "uid"]) as string;
  const user: any = state.getIn(["authorize", "user"]);
  const disableLogout: any = state.getIn(["global", "disableLogout"]);

  return {
    uid,
    user,
    disableLogout,
  };
};

const mapDispatchToProps = (dispatch: any, ownProps: ITopBarMenuComponentProps) => {
  return {
    logout: (group: any, subdomain?: any) => {
      dispatch(authorizeActions.dbLogout());

      if (window.location.pathname !== ("/signin" || "/login")) {
        if (subdomain) {
          window.location.assign(`${group ? "/signin" : "/login"}`)
        } else {
          if (group) {
            window.location.assign(`${group ? `/group/${group.slug}/signin` : `/group/${group.slug}/login`}`)
          } else {
            window.location.assign('/login');
          }
        }
      }
    }
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TopBarMenuComponent as any) as any
) as any;
